export enum TrackingTarget {
    gtag = 'gtag',
    fbq = 'fbq',
}

export enum EventType {
    signUpStep = 'sign_up_step',
}

interface Options {
    type: EventType;
}

export enum SignUpStep {
    landingPage = 'landing-page'
}

interface SubscriptionData {
    promo_code?: string;
}

export interface SignUpOptions extends Options {
    type: EventType.signUpStep;
    data: SubscriptionData & {
        step: SignUpStep;
        platform?: string,
    };
}

type AnyOptions = SignUpOptions;

export function fbqTrack(options: { type: string; data?: object }) {
    if ((window as any).fbq) {
        try {
            (window as any).fbq('track', options.type, {
                ...options.data,
            });
            // eslint-disable-next-line no-empty
        } catch (error) { }
    }
}

export function gtagEvent(options: AnyOptions) {
    if ((window as any).dataLayer) {
        try {
            (window as any).dataLayer.push({
                event: options.type,
                ecommerce: {
                    ...options.data,
                }
            });
            // eslint-disable-next-line no-empty
        } catch (error) {

        }
    }
}

export function trackEvent(options: AnyOptions, targets: TrackingTarget[] = [TrackingTarget.fbq, TrackingTarget.gtag]) {
    if (targets.indexOf(TrackingTarget.gtag) !== -1) gtagEvent(options);
    if (targets.indexOf(TrackingTarget.fbq) !== -1) fbqTrack(options);
}
